'use client';

import { useSubscriptionQuery } from '../api/billingApi';

/** Convenience wrapper around the RTK Query subscription endpoint. */
export function useSubscription() {
  return useSubscriptionQuery();
}
